<app-atom-respondant-edit
	*ngIf="respondant"
	[respondant]="respondant"
></app-atom-respondant-edit>
